/**
 * Statusse der Änderungen an Kundendaten
 *  */ 
export enum userDataChangesdataCategorieIds {
    compagnydata = '1',
    offerdata = '2',
    localchange = '3'
}